import React, { useEffect, useState } from "react";
import {
    Grid,
    InputLabel,
    FormControl,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useMediaQuery,
    FormHelperText,
    Typography,
    Checkbox,
    CircularProgress,
} from "@mui/material";
import styled, {
    inputImages,
    inputNumbers,
    inputStyles,
} from "../../Utils/inputChanges";

import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
    createItemEntry,
    fetchItemData,
    fetchItemMaterialData,
    insertItemMaterial,
} from "../../Store/PHPSlice/Item";
import {
    selectBrandlist,
    selectItemMaterialData,
    selectItems,
    selectlocationdata,
} from "../Selectors/Master/ItemSelectors";
import { fetchBrandData } from "../../Store/PHPSlice/Rack";
import Dropdown from "../FieldsComponents/Dropdown";
import { useParams } from "react-router-dom";
import { fetchLocationData } from "../../Store/PHPSlice/Transport";
import DropdownWithBtn from "../FieldsComponents/DropdownWithBtn";
import { fetchMaterialData } from "../../Store/PHPSlice/Material";
import { selectMaterials } from "../Selectors/Master/OutwardSelectors";
import { Preview } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import RadioComponent from "../FieldsComponents/RadioComponent";
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
const ItemMaterialEdit2 = () => {
    const userdata = JSON.parse(localStorage.getItem("user"));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        item: "",
        brand: "",
        userId: userdata?.ID,
        locId: "",
        sizewise: "0", // 👈 ADD THIS
        departId:"",
        matNm: "",
    });
    const [material, setMaterial] = useState([]);
    const [removeMaterial, setRemoveMaterial] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const itemlist = useSelector(selectItems);
    const brandlist = useSelector(selectBrandlist);
    const materialdata = useSelector(selectItemMaterialData);
    const loclist = useSelector(selectlocationdata);
    const departlist = useSelector(selectDaparement);
    

    const [sizeWise, setSizeWise] = useState([]);
    const [editIndex, setEditIndex] = useState(null); // To track which row is being edited

    const material_master = useSelector(selectMaterials);

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchBrandData());
        dispatch(fetchItemMaterialData(Id));
        dispatch(fetchLocationData());
        dispatch(fetchMaterialData());
        dispatch(fetchDepartmentData());
    }, [dispatch, Id]);

    // useEffect(() => {
    //     if (materialdata?.data?.length > 0) {
    //         let data = JSON.parse(JSON.stringify(materialdata?.data));

    //         setMaterial(data);
    //         const data2 = JSON.parse(JSON.stringify(materialdata?.data[0]));
    //         setFormData((prev) => ({
    //             ...prev,
    //             item: data2.itemId,
    //             brand: data2.brandId,
    //             departId:data2.departId
    //         }));
    //     }
    // }, [materialdata]);

   useEffect(() => {
    if (
        materialdata?.data?.length > 0 &&
        departlist?.data?.length > 0
    ) {
        const data = JSON.parse(JSON.stringify(materialdata.data));
        setMaterial(data);

        const data2 = materialdata.data[0];

        setFormData(prev => ({
            ...prev,
            item: data2.itemId,
            brand: data2.brandId,
            departId: data2.departId   // ✅ now safe
        }));
    }
}, [materialdata, departlist]);

    const isDesktop = useMediaQuery("(min-width:768px)");

    const tableContainerStyle = {
        marginTop: "1%",
        overflow: "hidden",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    };

    const webkitScrollbarStyle = {
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
    };

    const dropdownlistfirst = [
        {
            label: "Item",
            id: "item",
            options: itemlist?.data || [],
            value: formData.item,
            onChange: (newValue) =>
                handleDropdownChange(
                    { target: { name: "item", value: newValue ? newValue.ID : "" } },
                    "item"
                ),
            getOptionLabel: (option) => option.itemNm || "",
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find((item) => item.ID === value) || null;
                }
                return null;
            },
        },
        //    {
        //     label: 'Department',
        //     id: 'departId',
        //     options: departlist?.data || [],
        //     value: formData.departId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
        //     getOptionLabel: (option) => option.departNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //   //  errors: errors.departId
        // },
        {
            label: "Brand",
            id: "brand",
            options: brandlist?.data || [],
            value: formData.brand,
            onChange: (newValue) =>
                handleDropdownChange(
                    { target: { name: "brand", value: newValue ? newValue.ID : "" } },
                    "brand"
                ),
            getOptionLabel: (option) => option.brandNm || "",
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find((item) => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: "Material",
            id: "matId",
            options: material_master?.data || [],
            value: formData.matId,
            onChange: (newValue) =>
                handleDropdownChange(
                    { target: { name: "matId", value: newValue ? newValue.ID : "" } },
                    "matId"
                ),
            getOptionLabel: (option) => `${option.materialNm} - ${option.size}` || "",
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find((item) => item.ID === value) || null;
                }
                return null;
            },
            // handleAddNew: () => handleNavigateBrand(),
            // btnlabel: 'New',
            // handleDropdownOpen: () => handleDropdownOpen('matId'),
            // handleDropdownClose: () => handleDropdownClose('matId'),
        },
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value,
        });
    };

    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        updatematerial[index][name] = value;
        setMaterial(updatematerial);
    };

    const handleAddlump = () => {
        const selectMaterialObj = material_master?.data?.find(
            (item) => item.ID === formData.matId
        );
        
        const matNm = selectMaterialObj
            ? `${selectMaterialObj?.materialNm} - ${selectMaterialObj?.size}`
            : "0";
        const departNm=selectMaterialObj?.departNm;
        const materialdata = {
            ID: 0,
            matId: formData.matId,
            materialNm: matNm,
            departNm:departNm,
            qty: "0",
            sizewise: sizeWise,
            selected: false,
        };
        
        setMaterial((prevRows) => [...prevRows, materialdata]);
        setSizeWise([]);
        setFormData(prev => ({
            ...prev,
            sizewise: '0',
            matId: '',
            matNm: '',
        }))
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });
        
        if (value === "1" && formData.item !== "" && formData.matId !== "") {

            const selectmatNm = material_master?.data?.find(
                (item) => item.ID === formData.matId
            );

            // Get sizes from selected item
            const selectSize = itemlist?.data?.find(
                (item) => item.ID === formData.item
            )?.size;

            // If item has sizes, split by comma, else empty array
            const sizeArray =
                typeof selectSize === "string" && selectSize.trim() !== ""
                    ? selectSize.split(",")
                    : [""]; // default empty read-only size

            const objArray = sizeArray.map((size) => ({
                size: size.trim(), // read-only size
                matsize: "", // editable material size
                qty: "", // editable qty
            }));

            const matnm = `${selectmatNm?.materialNm}-${selectmatNm?.size || ""}`;
            setSizeWise(objArray);
            setEditIndex(0); // show table
            setFormData((prev) => ({
                ...prev,
                matNm: matnm,
            }));
        } else {
            setSizeWise([]);
            setEditIndex(null);
        }
    };

    const sizewiseoptions = [
        { label: "Yes", value: "1" },
        { label: "No", value: "0" },
    ];

    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleRemoveLumps = () => {
        const filteredRows = material.filter((row) => !row.selected);
        const removeRows = material.filter((row) => row.selected);
        setRemoveMaterial((prevRows) => [...prevRows, ...removeRows]);
        setMaterial(filteredRows);
        // const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        // setLumpTotMtr(totmtr);
    };

    function postObj(formData, material, removeMaterial) {
        const data = {
            itemId: formData.item,
            brandId: formData.brand,
            userId: formData.userId,
            material: material,
            delMaterial: removeMaterial,
            departId:formData.departId,
            locId: formData.locId,
        };
        return data;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const postdata = postObj(formData, material, removeMaterial);
            console.log(postdata);

            const result = await dispatch(insertItemMaterial(postdata)).unwrap();
            console.log("POST request successful!", result);
            // toast.success("Item Added");
            alert("Item Material Updated");
            // window.close();
        } catch (error) {
            console.error("Error while making POST request:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewData = (data, matNm, index, matId) => {
        console.log(matId);
        setEditIndex(index);
        setFormData((prev) => ({
            ...prev,
            sizewise: "1",
            matNm,
            matId
        }));

        let sizeArray = [];

        if (data && data.length > 0) {
            // Use existing sizewise data from material
            sizeArray = data.map((d) => ({
                size: d.size || "",
                matsize: d.matsize || "",
                qty: d.qty || "",
            }));
        } else {
            // Fallback: still show table with empty sizes (read-only)
            // const selectSize = materialdata?.data?.find(
            //     (m) => m.ID === material[index].ID
            // )?.sizewise;

            const selectSize = itemlist?.data?.find(i => i.ID === formData.item)?.size;
            const sizeArray2 = typeof selectSize === 'string'
                ? selectSize.split(',')
                : [];

            sizeArray = sizeArray2.map(size => ({
                size: size.trim(),
                matsize: '',
                qty: ''
            }));
        }
        setSizeWise(sizeArray);
    };


    const handleSizeWiseChange = (index, field, value) => {
        const updated = sizeWise?.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );

        setSizeWise(updated);

        if (editIndex !== null) {
            setMaterial((prev) =>
                prev.map((row, i) =>
                    i === editIndex ? { ...row, sizewise: updated } : row
                )
            );
        }
    };

    const handleCloseEditTable = () => {
        setEditIndex(null);
        setSizeWise([]);
        setFormData((prev) => ({
            ...prev,
            sizewise: "0", // 👈 resets radio
            matNm: "",
            matId: ''
        }));
    };

    return (
        <>
            <div style={{ margin: "1%" }}>
                <h2>Material Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: "2vh" }}>
                            <Grid container spacing={1.2}>

                                {dropdownlistfirst &&
                                    dropdownlistfirst?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder} // Pass `valueFinder` function here
                                        />
                                    ))}

                                <RadioComponent
                                    label="Size Wise"
                                    name="sizewise"
                                    value={formData.sizewise}
                                    options={sizewiseoptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />

                                {formData.sizewise === "1" &&
                                    editIndex !== null &&
                                    sizeWise.length > 0 && (
                                        <>
                                            {/* CLOSE ICON */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "22vh",
                                                    right: "2vw",
                                                    zIndex: 10,
                                                }}
                                            >
                                                <CloseIcon
                                                    className="cursor-pointer"
                                                    onClick={handleCloseEditTable}
                                                />
                                            </div>

                                            {/* TABLE */}
                                            <TableContainer
                                                style={{
                                                    ...tableContainerStyle,
                                                    ...webkitScrollbarStyle,
                                                }}
                                            >
                                                <Table>
                                                    <TableBody>
                                                        {/* SIZE ROW */}
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{
                                                                    p: 1,
                                                                    border: "1px solid #000",
                                                                    width: "150px",
                                                                }}
                                                                align="center"
                                                                className="tbl-row"
                                                            >
                                                                Size
                                                            </TableCell>

                                                            {sizeWise?.map((item, index) => (
                                                                <TableCell
                                                                    sx={{ p: 1, border: "1px solid #000" }}
                                                                    align="center"
                                                                    key={index}
                                                                >
                                                                    {item.size}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>

                                                        {/* MATERIAL SIZE ROW */}
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{
                                                                    p: 1,
                                                                    border: "1px solid #000",
                                                                    width: "150px",
                                                                }}
                                                                align="center"
                                                                className="tbl-row"
                                                            >
                                                                {formData.matNm}
                                                            </TableCell>

                                                            {sizeWise?.map((item, index) => (
                                                                <TableCell
                                                                    sx={{
                                                                        p: 1,
                                                                        border: "1px solid #000",
                                                                        width: "150px",
                                                                    }}
                                                                    align="center"
                                                                    key={index}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        value={item.matsize ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeWiseChange(
                                                                                index,
                                                                                "matsize",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        style={{ width: "50px" }}
                                                                    />
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>

                                                        {/* QTY ROW */}
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{
                                                                    p: 1,
                                                                    border: "1px solid #000",
                                                                    width: "150px",
                                                                }}
                                                                align="center"
                                                                className="tbl-row"
                                                            >
                                                                Qty
                                                            </TableCell>

                                                            {sizeWise?.map((item, index) => (
                                                                <TableCell
                                                                    sx={{
                                                                        p: 1,
                                                                        border: "1px solid #000",
                                                                        width: "150px",
                                                                    }}
                                                                    align="center"
                                                                    key={index}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        value={item.qty ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeWiseChange(
                                                                                index,
                                                                                "qty",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        style={{ width: "50px" }}
                                                                    />
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </>
                                    )}

                                <div className="lump-content">
                                    {/* <h3>Material Entry </h3> */}
                                    <div className="button-group">
                                        <button className="add" onClick={handleAddlump}>
                                            Add
                                        </button>
                                        <button className="delete" onClick={handleRemoveLumps}>
                                            Remove
                                        </button>
                                    </div>
                                    <table style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                {/* <th>Department</th> */}
                                                <th>Material</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {material?.map((mat, matIndex) => (
                                                <>
                                                    <tr key={matIndex}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={mat.selected}
                                                                onChange={() => handleLumpSelection(matIndex)}
                                                            />{" "}
                                                            {matIndex + 1}
                                                        </td>
                                                         {/* <td>
                                                            {mat.departNm}
                                                        </td> */}
                                                        <td>
                                                            {mat.materialNm}
                                                        </td>

                                                        <td>
                                                            <Preview
                                                                onClick={() =>
                                                                    handleViewData(
                                                                        mat.sizewise,
                                                                        mat.materialNm,
                                                                        matIndex,
                                                                        mat
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>

                                <Grid item xs={12} textAlign="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        disabled={loading === true}
                                    >
                                        {loading === true ? (
                                            <>
                                                <CircularProgress size="20px" /> wait...
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default ItemMaterialEdit2;
